import React, { FC } from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { findPartner } from "@/utils/constants/findPartner";
import { AspectRatio, Box, Flex } from "@radix-ui/themes";
import { Link } from "react-router-dom";

interface PartnerLogoProps {
  currentClient: string;
  isMobile?: boolean;
}

const PartnerLogo: FC<PartnerLogoProps> = ({
  currentClient,
  isMobile,
}): JSX.Element => {
  const isBestGamer = brand.brandValue === "BG";
  const isElgiganten = brand.brandValue === "ELGIGANTEN";
  const isLogitech = brand.brandValue === "LOGITECH";

  if ((isElgiganten || isBestGamer) && isMobile) {
    return (
      <Box>
        <Flex align="stretch" height="40px">
          {findPartner(currentClient) ? (
            <img
              src={findPartner(currentClient).logo.small}
              style={{
                height: "100%",
                objectFit: "contain",
                width: "100%",
              }}
            />
          ) : (
            <Link to="/home" style={{ display: "flex" }}>
              <img
                src={brand.logos.small}
                alt={brand.logos.alt_text}
                style={{
                  height: "100%",
                  objectFit: "contain",
                  width: "100%",
                }}
              />
            </Link>
          )}
        </Flex>
      </Box>
    );
  }

  return findPartner(currentClient) ? (
    <Link to={findPartner(currentClient).route}>
      <img src={findPartner(currentClient).logo.small} />
    </Link>
  ) : (
    isMobile && (
      <Link to="/home">
        <Flex style={{ height: "100%" }}>
          {brand.logos.small && (
            <img
              src={brand.logos.small}
              style={{
                width: "auto",
                height: "100%",
                minHeight: "2.5rem",
                maxHeight: "2.5rem",
              }}
              alt={brand.name}
            />
          )}
        </Flex>
      </Link>
    )
  );
};

export default PartnerLogo;
